import React from 'react'
import styled from 'styled-components'
import {MapContainer, TileLayer, MapContainerProps, Marker} from 'react-leaflet'
import mapStyles from './map.styles'

interface ApMapProps extends MapContainerProps {
  ap_latitude?: number
  ap_longitude?: number
  zoom?: number
}

const apAtomName = {ap_atom_name: 'mapAtom'}

const MapAtom = styled((props: ApMapProps) => {
  const {ap_latitude, ap_longitude, zoom} = props
  return ap_latitude && ap_longitude ? (
    <MapContainer
      {...apAtomName}
      {...props}
      center={[ap_latitude, ap_longitude]}
      zoom={zoom || 6}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={[ap_latitude, ap_longitude]} />
    </MapContainer>
  ) : null
})`
  ${mapStyles};
`
export default MapAtom
